import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LocationsApi } from '@core/api/locations.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { CustomCompileService } from '@core/services/custom-compile.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { PagedResult } from '@interfaces';
import { icon, latLngBounds, marker, tileLayer } from 'leaflet';
import { merge, Observable, Subject } from 'rxjs';
import { debounceTime, startWith, switchMap } from 'rxjs/operators';
import { FilterLocationsComponent } from '../../filter/filter-locations.component';
import { PopupMarkerComponent } from './popup-marker.component';

@Component({
  selector: 'map-locations',
  templateUrl: './map-locations.component.html',
  styleUrls: ['./map-locations.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapLocationsComponent implements OnInit {

  @Input() reload: Subject<void>;
  @Input() filters: FilterLocationsComponent;

  markerClusterGroup: any;
  fitBoundsOptions;
  markerClusterData: any[] = [];
  options: any = {
    layers: [tileLayer('https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7')],
    zoom: 5
  };

  constructor(
    private locationsApi: LocationsApi,
    private compile: CustomCompileService,
    private customMessageService: CustomMessagesService,
    private fuseProgressBarService: FuseProgressBarService,
  ) {
  }

  ngOnInit(): void {
    merge(this.reload, this.filters.filtersChanged)
      .pipe(
        startWith({}),
        debounceTime(500),
        switchMap(() => this.searchLocations())
      )
      .subscribe((data: PagedResult) => {
        this.fuseProgressBarService.hide();
        const locations = [];
        const boundsItems = [];
        data.items.forEach((location) => {
          const pointer = marker([location.address.coords.latitude, location.address.coords.longitude], {
            icon: icon({
              iconSize: [40, 40],
              iconAnchor: [20, 35],
              iconUrl: 'assets/images/icons/ic_place_24px.svg',
              popupAnchor: [0, -35]
            })
          });
          pointer.bindPopup(
            this.compile.compile(PopupMarkerComponent, (c) => {
              c.instance.location = location;
              c.instance.reload = () => {
                this.reload.next();
              };
            })
          );

          boundsItems.push([location.address.coords.latitude, location.address.coords.longitude]);
          locations.push(pointer);
        });

        if (!boundsItems.length) {
          boundsItems.push([-47.186656, -98.472544], [5.664193, -28.775281]);
          this.customMessageService.error('LOCATIONS.FILTER.NOT_FOUND');
        }

        this.fitBoundsOptions = latLngBounds(boundsItems);
        this.markerClusterData = locations;
      });
  }

  private searchLocations(): Observable<PagedResult> {
    this.fuseProgressBarService.show();
    return this.locationsApi.search(this.filters.filtersChanged.value, { limit: 9999 });
  }

  markerClusterReady(group: any): void {
    this.markerClusterGroup = group;
  }
}
